import { LogIntervalType } from "@/Administration/Models/UI/Enums/Administration";
import { ILogTabModel } from "@/Administration/Models/UI/Logs/ILogTabModel";
import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { CheckboxControl } from "@/Common/Components/Inputs/CheckboxControl";
import { CheckedListControl } from "@/Common/Components/Inputs/CheckedListControl";
import { MultiDateSelector } from "@/Common/Components/Inputs/MultiDateSelector";
import { TextboxControl } from "@/Common/Components/Inputs/TextboxControl";
import { SearchSettingsFooter } from "@/Common/Components/Settings/SearchSettingsFooter";
import { CheckboxTarget } from "@/Common/Models/UI/Inputs/CheckboxTarget";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";

interface ILogSearchSetting {
    Model: ILogTabModel;
    onClick?: any;
    id?: string;
    className?: string;
    style?: any;
}

class LogSearchSetting extends BaseReactComponent<ILogSearchSetting> {
    public componentDidMount(): void {
        super.setOverlay("LogSearchSetting", { transparent: true });
    }

    public render(): JSX.Element {
        let nbAccess = this.props.Model.get("NbAccess") ? this.props.Model.get("NbAccess").toString() : "";
        let interval = this.props.Model.get("Interval") ? this.props.Model.get("Interval").toString() : "";

        let isSelectAccessReportSelected = this.props.Model.get("IsAccessReportSelected");

        return (
            <div id={this.props.id} className={this.props.className} style={this.props.style} onClick={this.props.onClick}>
                <table className="f-content">
                    <thead>
                        <tr>
                            <th>
                                <label style={{ display: "inline" }}>{cacheStore.GetString("DateLabel")}</label>
                            </th>

                            <th>
                                <CheckboxControl
                                    id="user_check"
                                    label={cacheStore.GetString("UsersLabel")}
                                    operation={LocalOperations.AdministrationLog.SearchSettings_ContainerCheckboxChange}
                                    checked={this.props.Model.get("SelectAllUsersChecked")}
                                    target={CheckboxTarget.Myle_Admin_Log_Users_AllCheck}
                                    disabled={isSelectAccessReportSelected}
                                />
                            </th>
                            <th>
                                <CheckboxControl
                                    id="actiontype_check"
                                    label={cacheStore.GetString("ActionsLabel")}
                                    operation={LocalOperations.AdministrationLog.SearchSettings_ContainerCheckboxChange}
                                    checked={this.props.Model.get("SelectAllActionTypesChecked")}
                                    target={CheckboxTarget.Myle_Admin_Log_ActionTypes_AllCheck}
                                    disabled={isSelectAccessReportSelected}
                                />
                            </th>
                            <th>
                                <CheckboxControl
                                    id="accessReport_check"
                                    label={cacheStore.GetString("AccessReportLabel")}
                                    operation={LocalOperations.AdministrationLog.SearchSettings_ContainerCheckboxChange}
                                    checked={this.props.Model.get("IsAccessReportSelected")}
                                    target={CheckboxTarget.Myle_Admin_Log_AccessReport_Check}
                                />

                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <MultiDateSelector
                                    id="doc_search_date_selector"
                                    fromMyleOperation={LocalOperations.AdministrationLog.SearchSettings_FromDateChanged}
                                    toMyleOperation={LocalOperations.AdministrationLog.SearchSettings_ToDateChanged}
                                    fromSetTodayLabel={cacheStore.GetString("TodayLabel")}
                                    toSetTodayLabel={cacheStore.GetString("TodayLabel")}
                                    from={this.props.Model.get("DateFrom")}
                                    to={this.props.Model.get("DateTo")}
                                    errorMessage={administrationStore.getLogDateRangeErrorMessage()}
                                />
                            </td>
                            <td>
                                <input
                                    className="form-control"
                                    style={{ width: "225px" }}
                                    type="text"
                                    value={this.props.Model.get("UserSearchText")}
                                    onChange={this.onUserFilterTextChanged.bind(this)}
                                    placeholder={cacheStore.GetString("SearchLabel").toUpperCase()}
                                    disabled={isSelectAccessReportSelected}
                                />
                                <div style={{ maxHeight: "400px", maxWidth: "300px", overflow: "auto" }}>
                                    <CheckedListControl
                                        idModifier="user"
                                        DataSource={this.props.Model.get("UsersFiltered")}
                                        Operation={LocalOperations.AdministrationLog.SearchSettings_ContainerCheckboxChange}
                                        sort={true}
                                        limitTextWidth={true}
                                        disabled={isSelectAccessReportSelected}
                                        enableLazyRendering
                                    />
                                </div>
                            </td>
                            <td>
                                <input
                                    className="form-control"
                                    style={{ width: "225px" }}
                                    type="text"
                                    value={this.props.Model.get("ActionSearchText")}
                                    onChange={this.onActionFilterTextChanged.bind(this)}
                                    placeholder={cacheStore.GetString("SearchLabel").toUpperCase()}
                                    disabled={isSelectAccessReportSelected}
                                />
                                <div style={{ maxHeight: "400px", maxWidth: "300px", overflow: "auto" }}>
                                    <CheckedListControl
                                        idModifier="actiontype"
                                        DataSource={this.props.Model.get("ActionTypeFiltered")}
                                        Operation={LocalOperations.AdministrationLog.SearchSettings_ContainerCheckboxChange}
                                        disabled={isSelectAccessReportSelected}
                                    />
                                </div>
                            </td>
                            <td>
                                <TextboxControl
                                    valid={administrationStore.areLogAccessReportFieldsValid()}
                                    maxLength={5}
                                    className="form-control text-uppercase"
                                    style={{ width: "250px", marginBottom: "5px" }}
                                    type="text"
                                    IsNumeric={true}
                                    operation={LocalOperations.AdministrationLog.SearchSettings_NbAccessTextChanged}
                                    value={nbAccess}
                                    placeholder={cacheStore.GetString("AccessNumberLabel").toUpperCase()}
                                    disabled={!isSelectAccessReportSelected}
                                />
                                <div className="form-group">
                                    <TextboxControl
                                        valid={administrationStore.areLogAccessReportFieldsValid()}
                                        maxLength={5}
                                        containerCssClass="d-inline"
                                        className="form-control d-inline text-uppercase"
                                        style={{ width: "135px", marginRight: "5px" }}
                                        IsNumeric={true}
                                        type="text"
                                        operation={LocalOperations.AdministrationLog.SearchSettings_IntervalTextChanged}
                                        value={interval}
                                        placeholder={cacheStore.GetString("IntervalLabel").toUpperCase()}
                                        disabled={!isSelectAccessReportSelected}
                                    />
                                    <select disabled={!isSelectAccessReportSelected} className="form-control d-inline text-uppercase" style={{ width: "110px" }} onChange={e => this.onIntervalTypeSelectionChanged(e)} value={this.props.Model.get("IntervalType") + ""}>
                                        <option className="text-uppercase" key={"IntervalType_" + LogIntervalType.Minute} value={`${LogIntervalType.Minute}`}>{cacheStore.GetString("MinutesLabel")}</option>
                                        <option className="text-uppercase" key={"IntervalType_" + LogIntervalType.Hour} value={`${LogIntervalType.Hour}`}>{cacheStore.GetString("HoursLabel")}</option>
                                        <option className="text-uppercase" key={"IntervalType_" + LogIntervalType.Day} value={`${LogIntervalType.Day}`}>{cacheStore.GetString("DaysLabel")}</option>
                                    </select>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <SearchSettingsFooter
                    onClose={() => sessionStore.dispatch(LocalOperations.AdministrationLog.SearchSettings_Close)}
                    onOk={() => sessionStore.dispatch(LocalOperations.AdministrationLog.SearchSettings_OkClick)}
                    onColumnOrderingButtonClick={() => sessionStore.dispatch(LocalOperations.AdministrationLog.SearchSettings_ColumnOrderingPopup_Open)}
                    onResultsPerPageChange={value => sessionStore.dispatch(LocalOperations.AdministrationLog.SearchSettings_OnResultsPerPageChange, { value })}
                    selectedPageSizeOption={this.props.Model.get("SelectedPageSizeOption")}
                    pageSizeOptions={this.props.Model.get("PageSizeOptions").toArray()}
                    disableOkButton={!!administrationStore.getLogDateRangeErrorMessage()}
                />
            </div>
        );
    }

    public onUserFilterTextChanged(event: React.ChangeEvent<HTMLInputElement>): void {
        var operation = new LocalEvent(LocalOperations.AdministrationLog.SearchSettings_UserFilterTextChanged);
        operation.AddItem("value", event.target.value);
        LocalEventDispatcher.dispatch(operation);
    }

    public onActionFilterTextChanged(event: React.ChangeEvent<HTMLInputElement>): void {
        let operation = new LocalEvent(LocalOperations.AdministrationLog.SearchSettings_ActionFilterTextChanged);
        operation.AddItem("value", event.target.value);
        LocalEventDispatcher.dispatch(operation);
    }

    public onIntervalTypeSelectionChanged(e: React.ChangeEvent<HTMLSelectElement>): void {
        var operation = new LocalEvent(LocalOperations.AdministrationLog.SearchSettings_IntervalTypeChanged);
        operation.AddItem("value", e.target.value);
        LocalEventDispatcher.dispatch(operation);
    }
}

export { LogSearchSetting };
